<template>
  <div>
    <v-form ref="formulaireDon" :disabled="loading" lazy-validation>
      <h2 class="headline mb-2">{{ $t("collecte.contribuez") }}</h2>
      <div v-if="typeDeDon === 'unique'">
        <SelectionMontant :montants="[25, 50, 75]" v-model="montantDonUnique" :disabled="loading" />
      </div>
      <h2 class="mb-2 headline">{{ $t("formulaireDon.donateur") }}</h2>

      <LoadingComponent :loading="loadingCatalogues">
        <v-radio-group row v-model="civilite" :rules="required">
          <v-radio v-for="civilite in catalogues.civilites" :key="civilite.id" :value="civilite.id">
            <template v-slot:label>{{ civilite[$i18n.locale] }}</template>
          </v-radio>
        </v-radio-group>
      </LoadingComponent>

      <v-text-field v-model="courriel" outlined :rules="requiredEmail" id="courriel">
        <template v-slot:label>{{ $t("infosPersonnelles.courriel") }} *</template>
      </v-text-field>
      <v-text-field v-model="prenom" outlined :rules="required" id="prenom">
        <template v-slot:label>{{ $t("infosPersonnelles.prenom") }} *</template>
      </v-text-field>
      <v-text-field v-model="nom" outlined :rules="required" id="nom">
        <template v-slot:label>{{ $t("infosPersonnelles.nom") }} *</template>
      </v-text-field>
      <v-select v-model="anneeNaissance" outlined :items="anneesDeNaissance">
        <template v-slot:label>{{ $t("infosPersonnelles.anneeNaissance") }}</template>
      </v-select>
      <v-checkbox v-model="isCorporatif" class="mt-0">
        <template v-slot:label>{{ $t("formulaireDon.donCorporatif") }}</template>
      </v-checkbox>
      <v-text-field v-model="societe" outlined v-if="isCorporatif" :rules="required" id="societe">
        <template v-slot:label>{{ $t("formulaireDon.societe") }} *</template>
      </v-text-field>

      <h2 class="mb-2 headline">{{ $t("formulaireDon.adresse") }}</h2>
      <v-text-field v-model="adresse" outlined :rules="required" id="adresse-field" ref="adresse-field">
        <template v-slot:label>{{ $t("adresse.adresse") }} *</template>
      </v-text-field>
      <v-text-field v-model="ville" outlined :rules="required" id="ville">
        <template v-slot:label>{{ $t("adresse.ville") }} *</template>
      </v-text-field>
      <v-text-field v-model="codePostal" outlined v-facade="'A#A #A#'" :rules="codePostalRules" id="code-postal">
        <template v-slot:label>{{ $t("adresse.codePostal") }} *</template>
      </v-text-field>

      <LoadingComponent :loading="loadingCatalogues">
        <v-autocomplete :items="catalogues.provinces" v-model="province" outlined :item-text="$i18n.locale" item-value="id" :rules="required">
          <template v-slot:label>{{ $t("adresse.province") }} *</template>
        </v-autocomplete>
      </LoadingComponent>
      <v-text-field v-model="telephone" outlined v-facade="'(###) ### ####'" :rules="phoneRules" id="telephone">
        <template v-slot:label>{{ $t("adresse.telephone") }} *</template>
      </v-text-field>
      <v-text-field v-model="telephoneAuTravail" outlined v-facade="'(###) ### ####'" :rules="optionalPhoneRules" id="telephone-travail">
        <template v-slot:label>{{ $t("adresse.telephoneAuTravail") }}</template>
      </v-text-field>
      <h2 class="mb-2 headline">{{ $t("collecte.commentaireTitre") }}</h2>
      <v-text-field v-model="commentaire" outlined id="commentaire" maxlength="300" :rules="[(v) => v.length <= 300 || $t('rules.messageTropLong')]">
        <template v-slot:label>{{ $t("collecte.commentaireLabel") }}</template>
      </v-text-field>
      <div v-if="commentaire">
        <v-checkbox v-model="commentaireAnonyme" id="commentaireAnonyme">
          <template v-slot:label>{{ $t("collecte.commentaireAnonymeLabel") }}</template>
        </v-checkbox>
      </div>
      <v-checkbox v-model="montantDonMasque" id="montantDonMasque">
        <template v-slot:label>{{ $t("collecte.montantDonMasqueLabel") }}</template>
      </v-checkbox>
    </v-form>
    <v-btn block color="primary" class="mt-6" large @click="payNow" :disabled="loading" :loading="loading">{{
      $t("formulaireDon.boutonPaiement")
    }}</v-btn>
    <p class="caption mt-6 font-italic">
      {{ $t("formulaireDon.numeroFondation") }}
    </p>
  </div>
</template>

<script>
import LinkLogo from "@/components/common/LinkLogo"
import Account from "@/components/common/Account.vue"
import SelectionMontant from "@/components/common/SelectionMontant.vue"
import SelectionType from "@/components/common/SelectionType.vue"
import ChangeLocale from "@/components/common/ChangeLocale"
import LoadingComponent from "@/components/common/LoadingComponent"
import AlerteEspaceMembre from "@/components/common/AlerteEspaceMembre"

import CataloguesLoader from "@/mixins/CataloguesLoader"
import PosteCanada from "@/mixins/PosteCanada"
import InfosPersonnellesModel from "@/mixins/InfosPersonnellesModel"
import PaysafeModale from "@/mixins/PaysafeModale"

import Rules from "@/mixins/Rules"
import { Api } from "@/plugins/api"
import { mapGetters } from "vuex"
export default {
  mixins: [CataloguesLoader, PosteCanada, InfosPersonnellesModel, Rules, PaysafeModale],
  data() {
    return {
      cataloguesToLoad: ["civilites", "provinces"],
      montantDonUnique: 25,
      typeDeDon: "unique",
      isCorporatif: false,
      societe: "",
      loading: false,
      commentaire: "",
      commentaireAnonyme: false,
      montantDonMasque: false
    }
  },

  methods: {
    payNow() {
      if (!this.$refs.formulaireDon.validate()) {
        return
      }
      this.loading = true
      const montant = this.montantDonUnique
      this.showPaysafeModale(montant, `${this.prenom} ${this.nom}`)
    },

    onSuccessPaysafe(token) {
      this.loading = true
      let payload = {
        adresse: this.adresse,
        civilite: this.civilite,
        codePostal: this.codePostal,
        courriel: this.courriel,
        isCorporatif: this.isCorporatif,
        montant: this.montantDonUnique,
        nom: this.nom,
        prenom: this.prenom,
        province: this.province,
        societe: this.societe,
        telephone: this.telephone,
        telephoneAuTravail: this.telephoneAuTravail,
        typeDeDon: this.typeDeDon,
        ville: this.ville,
        paymentToken: token,
        langue: this.$i18n.locale,
        anneeNaissance: this.anneeNaissance,
        identifiantCollecte: this.$route.params.identifiantCollecte,
        identifiantObjectif: this.$route.params.identifiantObjectif,
        commentaire: this.commentaire,
        commentaireAnonyme: this.commentaireAnonyme,
        montantDonMasque: this.montantDonMasque
      }
      Api.post("/donations", payload)
        .then((res) => {
          const paiementReussi = res.data.paiementReussi
          if (paiementReussi) {
            this.$router.push({
              name: "RemerciementDon",
              query: {
                ...this.$route.query,
                identifiantCollecte: this.$route.params.identifiantCollecte,
                identifiantObjectif: this.$route.params.identifiantObjectif
              }
            })
          } else {
            this.$router.push({ name: "ErreurPaiement", query: this.$route.query })
          }
        })
        .catch(() => {
          this.$router.push({ name: "ErreurPaiement", query: this.$route.query })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onCloseBeforePayment() {
      this.loading = false
    }
  },
  computed: {
    ...mapGetters(["catalogues"]),
    types() {
      return [{ id: "unique", text: this.$t("formulaireDon.unique") }]
    }
  },
  components: {
    LinkLogo,
    Account,
    SelectionMontant,
    SelectionType,
    ChangeLocale,
    LoadingComponent,
    AlerteEspaceMembre
  },
  mounted() {
    this.$i18n.locale = this.$route.query.lang || "fr"
  }
}
</script>

<style>
</style>